import { Injectable, computed, signal } from '@angular/core';
// import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  private _entorno = signal<string>(sessionStorage.getItem('entorno') || '');
  private _usuario = signal<string>(sessionStorage.getItem('dusuario') || '');
  private _rol = signal<string>(sessionStorage.getItem('descnivelportal') || '');
  private _isAuthenticated = signal<boolean>(
    !!sessionStorage.getItem('dusuario') && sessionStorage.getItem('chgpass') !== 'S'
  );

  public readonly entorno = this._entorno.asReadonly();
  public readonly usuario = this._usuario.asReadonly();
  public readonly rol = this._rol.asReadonly();
  public readonly isAuthenticated = this._isAuthenticated.asReadonly();

  public readonly hasAdminRole = computed(() => this._rol().toLowerCase().includes('admin'));

  constructor() {}

  public initializeFromSession(): void {
    this._entorno.set(sessionStorage.getItem('entorno') || '');
    this._usuario.set(sessionStorage.getItem('dusuario') || '');
    this._rol.set(sessionStorage.getItem('descnivelportal') || '');
    this._isAuthenticated.set(
      !!sessionStorage.getItem('dusuario') && sessionStorage.getItem('chgpass') !== 'S'
    );
  }

  public updateUserInfo(userData: { entorno?: string; usuario?: string; rol?: string }): void {
    if (userData.entorno) {
      this._entorno.set(userData.entorno);
      sessionStorage.setItem('entorno', userData.entorno);
    }

    if (userData.usuario) {
      this._usuario.set(userData.usuario);
      sessionStorage.setItem('dusuario', userData.usuario);
    }

    if (userData.rol) {
      this._rol.set(userData.rol);
      sessionStorage.setItem('descnivelportal', userData.rol);
    }

    this._isAuthenticated.set(
      !!this._usuario() && sessionStorage.getItem('chgpass') !== 'S'
    );
  }

  public clearUserState(): void {
    sessionStorage.removeItem('entorno');
    sessionStorage.removeItem('dusuario');
    sessionStorage.removeItem('descnivelportal');
    sessionStorage.removeItem('chgpass');

    this._entorno.set('');
    this._usuario.set('');
    this._rol.set('');
    this._isAuthenticated.set(false);
  }
}
